import React, { useMemo } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import Router from 'Router';
import WithoutHeaderLayout from './WithoutHeaderLayout';
import MainLayout from './MainLayout';
import { useSelector } from 'react-redux';
import { userSelector } from 'redux/selectors/userSelector';

export default function AppLayout(props: any) {
	const { isAuthenticated, user } = useAuth0();
	const userData = useSelector(userSelector);
	const Layout = useMemo(() => {
		//@ts-ignore
		if (!isAuthenticated || !user?.email_verified) {
			return WithoutHeaderLayout;
		}

		return MainLayout;
	}, [isAuthenticated, user, userData]);

	return (
		<Layout>
			<Router />
		</Layout>
	);
}
